module.exports = __webpack_public_path__ + "al.c521e40e.svg";